import { Injectable } from '@angular/core';
import { OBaseGrpcService } from '@olameter/o-utilities';
import { from, Observable, switchMap } from 'rxjs';
import { OConfigService } from '@olameter/o-config-service';
import {  WorkOrderInstallDateServiceClient
} from '../proto/generated/wo_install_date_service_pb_service';
import { SharedUtilService } from '../CommonFiles/utilities/shared-util.service';
import { InstallDate, WorkOrderInstallDate } from '../proto/generated/wo_install_date_message_pb';
import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';
import { InstallDateRequest, InstallDateResultResponse } from '../proto/generated/wo_install_date_service_pb';
import { WorkOrderModel } from '../CommonFiles/BusinessModels';

import { OAuthService } from '@olameter/o-authentication';

@Injectable()
export class InstalldDateGRPCService extends OBaseGrpcService<any> {
  get(data: any): Observable<any[]> {
    throw new Error('Method not implemented.');
  }
  create(data: any): Observable<any[]> {
    throw new Error('Method not implemented.');
  }
  update(data: any): Observable<any[]> {
    throw new Error('Method not implemented.');
  }
  delete(data: any): Observable<any[]> {
    throw new Error('Method not implemented.');
  }
  _client: WorkOrderInstallDateServiceClient;
  
  constructor(
    private config: OConfigService,
    public sharedservice: SharedUtilService,
    private authService: OAuthService
  ) {
    super();
    this._client = new WorkOrderInstallDateServiceClient(
      this.config.getConfig().apiUrl
    );
  }

  set(data?: InstallDateDto): Observable<InstallDateResultDto[]> {
    return from(this.authService.getGrpcAuthorizationRequestOption()).pipe( 
      switchMap((requestOptions) => {
        return new Observable<InstallDateResultDto[]>((observer) => {
          let request:InstallDateRequest = new InstallDateRequest();
          request.setRequest(new InstallDate());
          request.getRequest().setWorkOrdersList(data.workorders.map(x=> { 
            let data:WorkOrderInstallDate = new WorkOrderInstallDate();
            data.setName(x.name);
            data.setContractName(x.contractname);
            data.setServiceType(x.servicetype);
            return data;
          }));
          let timestamp = new Timestamp();
          timestamp.fromDate(data.date)
          request.getRequest().setDate(timestamp);
          request.getRequest().setRemove(data.remove);
          request.getRequest().setAll(data.all);

          this._client.setInstallDate(request, requestOptions,(error, response: InstallDateResultResponse) => {
            if (error) {
              this.authService.processError(error);
              return this.handleError(error);
            }
            if (response) {
              let list:InstallDateResultDto[] = [];
              let result: InstallDateResultDto = {};
              result.computed = WorkOrderModel.MapperList(response.getResult().getComputedList());
              result.error = response.getResult().getErrorList().map(error => { return {name : error.getWorkOrderName(), message : error.getMessage() } as InstallDateErrorDto});
              list.push(result);
              observer.next(list);
              observer.complete();
              this.sharedservice.handleBackendResponse(null, response);
            }
          });
        });
      })
    )
  }
}

export interface InstallDateResultDto
{
  computed?:WorkOrderModel[];
  error?:InstallDateErrorDto[];
}

export interface WorkOrderInstallDateDto
{
  name?:string;
  servicetype?:string;
  contractname?:string;  
}

export interface InstallDateDto
{
  workorders?:WorkOrderInstallDateDto[];
  contractname?:string,
  servicetypes?:string[];
  date?:Date,
  remove?:boolean,
  all?:boolean
}

export interface InstallDateErrorDto{
  name?:string;
  message?:string;
}